export default __webpack_public_path__ + "static/kanban-view-m-055e1846a777a2c1cc9261385c1657db.webp";